import EventOverviewPageActionTypes from '../actions/event-overview-page-action-types';

const initialState = {
  loading: false,
  event: null,
  cancelToken: null,
  selectedTab: 0,
  canWrite: false,
  isConfirmDialogVisible: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case EventOverviewPageActionTypes.LOAD_EVENT_OVERVIEW_PAGE_START:
      return {
        ...state,
        loading: true
      };
    case EventOverviewPageActionTypes.LOAD_EVENT_OVERVIEW_PAGE_END:
      return {
        ...state,
        loading: false,
        event: action.payload?.event,
        canWrite: action.payload?.canWrite
      };
    case EventOverviewPageActionTypes.SELECT_EVENT_OVERVIEW_PAGE_TAB:
      return {
        ...state,
        selectedTab: action.payload?.selected
      };
    case EventOverviewPageActionTypes.CHANGE_EVENT_STATUS_START:
      return {
        ...state,
        loading: true
      };
    case EventOverviewPageActionTypes.CHANGE_EVENT_STATUS_END:
      return {
        ...state,
        loading: false
      };
    case EventOverviewPageActionTypes.TOGGLE_EVENT_OVERVIEW_CONFIRM_DIALOG:
      return {
        ...state,
        isConfirmDialogVisible: action.payload?.isVisible ?? false,
        confirmDialogErrorMessage: action.payload?.errorMessage
      };
    default:
      return state;
  }
};
